import { render, staticRenderFns } from "./downloadTestThroughEmail.vue?vue&type=template&id=5e5cea1d&scoped=true&"
import script from "./downloadTestThroughEmail.vue?vue&type=script&lang=js&"
export * from "./downloadTestThroughEmail.vue?vue&type=script&lang=js&"
import style0 from "./downloadTestThroughEmail.vue?vue&type=style&index=0&id=5e5cea1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5cea1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VOverlay})
